<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue';
import IconChatParticipants from '../../icons/IconChatParticipants.vue';
import IconEdit from '../../icons/IconEdit.vue';
import IconLeave from '../../icons/IconLeave.vue';
import IconMore from '../../icons/IconMore.vue';
import IconSave from '../../icons/IconSave.vue';
import IconTrash from '../../icons/IconTrash.vue';
import Tooltip from './tooltip/Tooltip.vue';

const props = defineProps({
  canRemove: Boolean,
  renameGroup: Function,
  chatParticipants: Function,
  group: Object,
  saveMessages: Function,
  removeGroup: Function,
  exitGroup: Function,
  inSession: Boolean,
});

const state = ref(false);
const tooltip = ref({
  visible: false,
  target: null,
  targetLeft: false,
  text: '',
  initial: 'bottom',
  xPosition: 'center',
});

function toggleDropdown(e) {
  state.value = !state.value;
  if (state.value) handleTooltipClose();
}

function close(e) {
  if (!e.target.closest('.dropdown')) {
    state.value = false;
  }
}

async function handleTooltipMouseEnter(e) {
  if (tooltip.value.target !== e.target) tooltip.value.visible = false;
  await nextTick();
  tooltip.value = {
    ...tooltip.value,
    target: e.target,
    text: 'Menu',
    initial: 'bottom',
    xPosition: 'center',
    targetLeft: false,
    visible: true,
  };
}

function handleTooltipMouseLeave() {
  tooltip.value.targetLeft = true;
}

function handleTooltipClose() {
  tooltip.value = {
    ...tooltip.value,
    visible: false,
    targetLeft: false,
    target: null,
    text: '',
    initial: 'bottom',
    xPosition: 'center',
  };
}

onMounted(() => {
  document.addEventListener('click', close);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', close);
});
</script>

<template>
  <div class="dropdown" :class="{ shown: state }">
    <tooltip
      v-if="tooltip.visible && !state"
      :text="tooltip.text"
      :initial="tooltip.initial"
      :x-position="tooltip.xPosition"
      :target-left="tooltip.targetLeft"
      :rect="tooltip.target?.getBoundingClientRect()"
      @close="handleTooltipClose"
    />
    <button
      class="dropdown__btn"
      @click.prevent="toggleDropdown"
      @mouseenter="handleTooltipMouseEnter"
      @mouseleave="handleTooltipMouseLeave"
    >
      <icon-more />
    </button>
    <ul ref="messages" v-show="state">
      <li v-if="canRemove" @click="renameGroup"><icon-edit /> Rename Chat</li>
      <li @click="chatParticipants">
        <icon-chat-participants /> Chat Participants
      </li>
      <li @click="saveMessages"><icon-save /> Save Chat Text</li>
      <li
        v-if="canRemove"
        class="dropdown-delete"
        @click="removeGroup"
      >
        <icon-trash size="24" /> Delete Chat
      </li>
      <li v-else-if="!inSession && !group?.isSessionGroup" @click="exitGroup"><icon-leave /> Leave Chat</li>
    </ul>
  </div>
</template>
